<template>
    <v-card flat color="transparent" style="padding-bottom: 70px">
              
                  <v-card-text class="pt-0">
              <v-list dense color="transparent">
                  
                        <!--v-subheader class="primary--text pl-0">Uw vragenlijst</v-subheader-->
                            
                             <core-empty v-if="questions.filter(q => !hasAnswered(q)).length+available_extra.length==0" icon="list" text="Vragenlijst" description="Maak hier uw vragenlijst door de standaard vragen binnen uw branche toe te voegen of zelf vragen toe te voegen">
                                 <center slot="content" ><v-btn small @click="addAll" color="primary">
                                    Alle suggesties gebruiken
                                  </v-btn></center>
                                 
                             </core-empty>
               
                      <template v-for="(question, ii) in questions.filter(q => !hasAnswered(q))">
                          <v-divider v-if="getOptional(question, ii)" class="ml-4"></v-divider>
                          <!--v-subheader v-if="getOptional(question, ii)" v-bind:key="question.title" class="primary--text pl-0">Aanvullende vragen</v-subheader-->
                                
        
                          <v-hover v-slot:default="{ hover }" v-bind:key="ii">
                            
                            <v-list-item @contextmenu.prevent="context(question)" @click="select(question,ii,isMain)" >
                                <v-list-item-icon style="margin-left: -25px;position:absolute" v-if="question.description">
                                    <v-icon v-if="listitem == ii">expand_more</v-icon>
                                    <v-icon v-else>navigate_next</v-icon>
                                  </v-list-item-icon>
                               <v-list-item-content class="my-0 py-0">
                                  <v-list-item-title  :class="{'my-0 py-0': true, handle: true, 'indigo--text': false , 'text--lighten-3': false}" style="white-space: normal;" v-text="getTitle(question)"></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="my-0" v-if="question.type=='radio' && hover && !hasAnswered(question) && !isMain" style="position:absolute;z-index:10;right:10px;background-color: #F1F1F1">
                                    <div>
                                            <v-btn v-for="option in question.options" small text color="indigo" class="normal" @click.stop="select(question,ii,option)">{{option}}</v-btn>
                                             <v-icon>chevron_right</v-icon>
                                             </div>
                                </v-list-item-action>
                                <v-list-item-action class="my-0 pt-2" v-else-if="hover && !isMain">
                                    <v-btn small text color="indigo" class="normal" @click.stop="select(question,ii,true)">Vraag <v-icon>chevron_right</v-icon></v-btn>
                                   
                                </v-list-item-action>
                              </v-list-item>
                              </v-hover>
                              <v-list-item v-if="question.description && listitem == ii" style="margin-top:-10px">
                                  <v-list-item-content class="grey--text">
                                    {{question.description}}
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                    </v-list>
                    <v-divider class="ml-4 mb-2" v-if="available_extra.length>0 && questions.filter(q => !hasAnswered(q)).length > 0"></v-divider>
                   <v-toolbar dense flat color="transparent" v-if="available_extra.length>0 && questions.filter(q => !hasAnswered(q)).length > 0">
                      <v-toolbar-title class="blue--text text--darken-1 subtitle-1" v-if="Role('lead')">Algemene vragenlijst</v-toolbar-title>
                      <v-toolbar-title class="blue--text text--darken-1 subtitle-1" v-if="Role('admin')">Knelpunten</v-toolbar-title>
                      <v-spacer></v-spacer>
                         </v-toolbar>
                      <v-list subheader dense>
                              <template v-for="(question, ii) in available_extra">
                              <v-hover v-slot:default="{ hover }">
                                     <v-list-item @contextmenu.prevent="context(question)" @click="select(question,ii,isMain)" >
                                <v-list-item-icon style="margin-left: -25px;position:absolute" v-if="question.description">
                                    <v-icon v-if="listitem == ii">expand_more</v-icon>
                                    <v-icon v-else>navigate_next</v-icon>
                                  </v-list-item-icon>
                               <v-list-item-content class="my-0 py-0">
                                  <v-list-item-title  :class="{'my-0 py-0': true, handle: true, 'indigo--text': false , 'text--lighten-3': false}" style="white-space: normal;" v-text="getTitle(question)"></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="my-0" v-if="question.type=='radio' && hover && !hasAnswered(question) && !isMain" style="position:absolute;z-index:10;right:10px;background-color: #F1F1F1">
                                    <div>
                                            <v-btn v-for="option in question.options" small text color="indigo" class="normal" @click.stop="select(question,ii,option)">{{option}}</v-btn>
                                             <v-icon>chevron_right</v-icon>
                                             </div>
                                </v-list-item-action>
                                <v-list-item-action class="my-0 pt-2" v-else-if="hover && !isMain" style="position:absolute;z-index:10;right:10px;background-color: #F1F1F1">
                                    <v-btn small text color="indigo" class="normal" @click.stop="select(question,ii,true)">Vraag <v-icon>chevron_right</v-icon></v-btn>
                                    
                                </v-list-item-action>
                              </v-list-item>
                              </v-hover>
                              <v-list-item v-if="question.description && listitem == ii" style="margin-top:-10px">
                                  <v-list-item-content class="grey--text">
                                    {{question.description}}
                                    </v-list-item-content>
                                </v-list-item>
                                </v-hover>
                                </template>
                      </v-list>
                    <slot></slot>
                        
            </v-card-text>
           
           <v-footer fixed style="bottom:20px" color="#f9f9f9" class="pa-5">
               <questionaire-add v-if="preview" :loading="loading"  @add="save" @menu="tab='list'"></questionaire-add> 
           </v-footer>
    </v-card>
                    
</template>

<script>
import goTo from 'vuetify/es5/services/goto'
import draggable from "vuedraggable";
//import goTo from 'vuetify/es5/services/goto'
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters
} from 'vuex'

export default {
    
    name: 'questionaire-list',
    props: ['item', "max", "number","isMmain","disabled","template","loading","isMain"],
    data: () => ({
        all: false,
        listicon: false,
        listitem: -1,
        print: false,
        panel: -1,
        active: 1,
        modified: false,
        extra: '',
        overlay: false,
        answer: {},
        nn: false,
        drag: false,
        dragIndex: -1,
        dialog: false,
        dialogEdit: false,
        optional: -1
    }),
    computed: {
        ...mapState('app', ["preview"]),
         ...mapState('auth', ['authenticated',"settings","role"]),
         ...mapState('match', ['selected','list','templates']),
         ...mapGetters('match', ['question','matchCount','search','currentQuestion']),
         ...mapGetters('auth', ["Role","maincontact","relation"]),
        dragOptions() {
          return {
            animation: 100,
            disabled: false,
            //ghostClass: "ghost",
            pull: 'clone', put: true
          };
        },
        show_tracks () {
         return  (this.matchCount > 0) ? true : false
        },
        answerProto (){
            return { 
                    owner: {email: this.maincontact.email, name: this.maincontact.name, avatar: this.maincontact.avatar, organisation: this.relation.name, role: this.role}, 
                    date: new Date()
                }
        },
       index () {
           return this.selected._id
       },
       
       questions () {
          return this.selected.questions
          /*.map(function(q){
              q.checks = []
              return q
          });*/
      },
       available_extra () {
        if (this.Role('_supplier')) return []
        var self = this
        return this.templates.filter(
            q => 
            !q.answer && q.type == 'text' &&
            (self.selected.questions.filter(t => t.title == q.title).length==0
               || q.linkto.filter(value => self.tags.includes(value)).length > 0 )
            )
    }   ,
      unAnswered(){
          var self = this
        return this.questions.filter(q => !self.hasAnswered(q)).length
      },
      tags (){
       if (this.selected.tags) return this.selected.tags.filter(q=> q.type=='branche' || q.type=='category' || q.type=='type').map(t => {
            if (t.type == 'category' || t.type == 'type') {
              t.path = t.path.replaceAll(' / ', '###')
              t.name = t.path.split('/').map(c => c.capitalize()).join(', ').replaceAll('###',' / ')
            }
            return t.name
        }) //
        return []
      },
      messages () {
        if (!this.answers) return []
        return this.answers.filter(a => a.question == null)
      },
      
      currentQuestion: {
            get() {
                 return this.question
            },
            set(value) {
                this.setQuestion(value)
            }
      },
      
      reports () {
          return this.selected.questions.filter(q => q.report)
      },
      answers () {
          return this.selected.answers
      }
    },
    watch: {
     panel (value, oldValue){
        //if (this.currentQuestion && this.currentQuestion.modified) this.answerThis(this.currentQuestion)
        
        /*if (value > -1 && this.questions[value]) {
            this.currentQuestion = this.questions[value]
            if (this.currentQuestion.type != 'text') this.dialog = true
            goTo('#questionCard')
        }*/
        
        //if (value && value > -1) goTo('#list_panel' + value)
      },
      modified (value, old) {
          //if (old == false && value == true) this.$emit('modified', this.questions, this.answers)
      },
      questions (){
        this.optional=-1
      },
      index (item,old){
         
      }
    },
    mounted() {
     this.panel = -1
     this.optional = -1
     if (this.questions[0]) this.currentQuestion = this.questions[0]
     
    },
   
    methods : {
        ...mapActions('auth', ["logout"]),
        ...mapActions('match', ["addAnswer","addQuestion"]),
        ...mapMutations('match', ["resetQuestions","deleteAnswer","deleteQuestion","setQuestion","addDescription","setSelected","removeQuestion","setModified","setSearch","sortQuestions"]),
        ...mapMutations('app', ["setMessage","togglePreview","setPreview","setMenu"]),
        
        next: function(event) {
             //if (event.key == "+")
       //{
          // do something
        this.panel++
        if (event) event.preventDefault();
       },
        load (settings){
         this.tab = "questions"
       },
       reset () {
        this.resetQuestions()  
        this.$emit('save')
      },
      select(question, ii, answer){
        if (!answer) {
            if (this.current(ii)){
                this.listitem = -1
            } else {
                this.listitem = ii
                this.currentQuestion = question
            }
             return true
        }
        question.checks=[]
         
        if (answer && answer != true) question.checks = [answer]
        if (question.type != "radio" || answer) {
            if (answer == 'NEE' && !question.no_answer) {
               this.delQuestion()
            } else {
                this.answerThis(question)
            }
        }
        //this.setPreview(true)
       if (!this.Role('lead')) goTo('#questionCard')
      },
      context(question) {
          question.optional=!question.optional;
          this.sortQuestions()
          this.optional = -1
          this.save()
      },
      getTitle(question){
         if (this.Role('supplier') && question.title_supplier) return question.title_supplier + this.questionMark(question) 
        return question.title + this.questionMark(question)  
      },
      current(ii){
        return (this.listitem == ii) 
        
        },
      getOptional(question, index) {
          //if (index == 0) this.optional = -1
          if (!question) return false
           if (question.optional && this.optional == -1) this.optional = index
            return this.optional == index
       },
       onDragMove(e) {
            },
            onDragStart(evt) {
               this.currentQuestion = this.questions[evt.oldIndex]
                this.currentQuestion.drag=true
                this.dragIndex = evt.oldIndex
                this.drag = true
            },
            onDragEnd(evt) {
              this.questions[evt.newIndex].drag=false
              this.dragIndex = -1
              this.drag = false  
              this.modified=true
              this.optional = -1
              this.save()
            
      
       },
       last() {
         this.panel = this.questions.length -1
       },
       mod(question){
         this.answerThis(question)
       },
       save() {
           this.$emit('save')
       },
       saveQuestion() {
         this.currentQuestion = Object.assign(this.currentQuestion,this.$refs.questionForm.q)
         this.setModified(true);
         this.dialogEdit = false  
       },
       delQuestion(){
         this.deleteQuestion(this.currentQuestion)
         this.setModified(true);
         this.dialogEdit = false  
       },
        saveAnswer(question){
           var self = this
           this.answerThis(question)
           setTimeout(() => self.next(), 500); 
           
        },
        answerThis (question) {
           if (!question) return false
           this.addQuestion(question) //ad tobe sure
        
          this.currentQuestion = question
          this.dialog = false
          question.modified = false
          //this.overlay = true
          //if (question.checks.length == 0 && question.type=='radio' && !question.score) return false
          this.answer = Object.assign({}, this.answerProto)
          this.answer._id = this.selected._id
          this.answer.question = question.title
          this.answer.supplier = question.title_supplier
          this.answer.weight = question.weight
          this.answer.text = question.comment
          this.answer.type = question.type
          this.answer.options = question.checks
          this.answer.answer = question.answer || question.title
          //if (this.Role('lead')){
              if (question.type == 'radio' && question.checks[0] == question.options[0] ) {
                this.answer.tag = question.tag
                this.answer.answer = question.answer || question.title
              }
              if (question.type == 'radio' && question.checks[0] == question.options[1]) {
                this.answer.tag = question.notag
                this.answer.answer = question.no_answer || question.answer || question.title
              }
          //}
         
          this.answer.score = question.score || 3
          
          this.addAnswer(this.answer)

            question.comment = null
            question.checks = []
            //this.next()
        },
        setScore (props) {
            props.click()
            this.answer.score = props.index+1
            this.addAnswer(this.answer)
            this.overlay = false
            this.next()
        },
        add(index){
            var q = this.questions.splice(index, 1)[0];
            delete q.match
            this.$emit('add', q, true)
        },
        addAll(){
            this.$emit('addAll')
            
        },
        addOption(question) {
            if (!question.extra || question.extra.length == 0) return false
            question.options.push(question.extra);
            //question.checks.push(question.extra)
            //console.log(question.checks)
            question.extra=''  
        },
        getAnswers(question) {
            if (!this.answers) return []
          return this.answers.filter(a => a.question == question.title)  
        },
        hasAnswered(question, value) {
            var self = this
            if (!this.answers || this.answers.length == 0 || !question) return false
            return this.answers.filter(a => 
                        a.question == question.title 
                        && (question.type=='text' || (a.options && a.options.length>0 && a.options[0] && (a.options[0] == value || !value))) 
                        ).length > 0
        },
        haveAnswered(question, value) {
            var self = this
            if (!this.answers || this.answers.length == 0 || !question) return false
            return this.answers.filter(a => 
                        a.question == question.title 
                        && (question.type=='text' || (a.options && a.options.length>0 && a.options[0] && (a.options[0] == value || !value))) 
                        && a.owner && a.owner.name == self.maincontact.name
                        ).length > 0
        },
        hasOwn () {
            return (this.selected.questions && this.selected.questions.length > 0) || (this.selected.answers && this.selected.answers.length > 0)
        },
        removeAnswer(answer) {
            this.deleteAnswer(answer)
            this.modified = true
        },
        removeAt(idx) {
           var self = this
            var q = this.removeQuestion(idx)
            setTimeout(() => {
               self.panel = []
              },100)
            
            //this.$emit('delete', q[0])
          },
         
        panel_id (panel){
          return 'list_panel' + panel
        },
      
        questionCustom (question) {
          return this.settings.questions.filter(q => q.title == question.title).length == 0
        },
        questionMark(question) {
              if (question.title && question.title.indexOf('?') == -1) return '?'
              return ''
          },
        hasTag(tag) {
            this.selected.tags.filter(q => q.tag == tag).length > 0
        },
        timeStamp (item){
            if (!item.date) return
            var m = this.$moment(item.date, this.$moment.ISO_8601)
            if (!m.isValid()) return this.$moment().format("dddd D MMMM [om] HH:mm")
            return m.format("dddd D MMMM [om] HH:mm");
          },
        avatar (url) {
          return this.$config.getIMageLink('logo',url,true)
        },
         updateInfo(text) {
          this.addDescription(text)
        }
    }
}


</script>
<style>
.v-expansion-panel.flat.elevation-0:not(.v-item--active) {
     background-color: transparent!important; 
}
.v-expansion-panel.flat.elevation-0:not(.v-item--active):before {
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}

.theme--light.v-expansion-panel.flat.elevation-0 .v-expansion-panel__container {
    border-top: 0px!important; 
    background-color: transparent!important; 
}


.elevation-0.flat .theme--light.v-text-field > .v-input__control > .v-input__slot:before{
    border-color: transparent!important;
}
.elevation-0.flat .theme--light.v-text-field > .v-input__control > .v-input__slot:after{
    border-color: RGBA(0,0,0,0.1);
}

.elevation-0.flat  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: transparent;
}
.ghost {
    display:none;
}
.v-stepper__label .v-btn--fab {
    position: absolute;
    right: 20px;
    margin-top: -10px;
    opacity: 0;
}
.v-stepper__step--active .v-stepper__label .v-btn--fab,
.v-stepper__step:hover .v-stepper__label .v-btn--fab{
    opacity:1;
}

.v-stepper, .v-stepper__header {
     -webkit-box-shadow: none!important; 
     box-shadow: none!important; 
}
.current-item {
   
}
.theme--light.v-expansion-panels .v-expansion-panel.current-item .v-expansion-panel-header {
    background-color: #8A80AA;
    color: #FFFFFF;
}
.v-expansion-panel-content .v-expansion-panel-content__wrap {
 margin: 0;
 padding:0;
}
.fixed-tabbar .v-tabs-bar{
        position: fixed;
    width: 100%;
    top: 0px;
    z-index: 1;
}
.fixed-tabbar .v-tabs-items {
    padding-top:34px;
}
.v-navigation-drawer__border {
    z-index: 10;    
}
.v-item-group.v-tabs-bar {
    display:none;
}
.v-list--dense .v-list-item .v-list-item__title {
    font-weight: 400;
}
.v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), 
.v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), 
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 0px; 
    
}
.v-btn--text.normal {
    font-weight: normal;
    text-transform: none;
    font-size: inherit;
    height:18px;
}
</style>